export default {"src":"/_next/static/media/dxbstay-light-logo.fd8cb341.svg","height":139,"width":501};